module.exports = __webpack_public_path__ + "static/img/global_handle.7450436.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_handle.gif
// module id = 4PKK
// module chunks = 297